import "twin.macro";

import React from "react";
import { useForm } from "react-hook-form";

import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { LoadingButton } from "@features/ui";
import { Brand } from "@models/Brand";
import { ControlledTextInput } from "@utils/forms";

import { useCreateBrandMutation, useUpdateBrandMutation } from "../data";

const BrandModal = ({
  handleClose,
  brand,
}: {
  handleClose: () => void;
  brand: Brand | null;
}) => {
  const createBrandMutation = useCreateBrandMutation();
  const updateBrandMutation = useUpdateBrandMutation();

  const error = createBrandMutation.error || updateBrandMutation.error;
  const isPending =
    createBrandMutation.isPending || updateBrandMutation.isPending;

  const { control, handleSubmit } = useForm({
    defaultValues: {
      name: brand?.name ?? "",
    },
  });

  const onSubmit = (data: any) => {
    if (brand) {
      updateBrandMutation.mutate(
        { id: brand.id, name: data.name },
        {
          onSuccess: () => {
            handleClose();
          },
        }
      );
    } else {
      createBrandMutation.mutate(
        { name: data.name },
        {
          onSuccess: () => {
            handleClose();
          },
        }
      );
    }
  };

  return (
    <Dialog open onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{brand ? "Edit Brand" : "Create Brand"}</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <ControlledTextInput
            name="name"
            control={control}
            label="Brand Name"
            rules={{ required: "Brand name is required" }}
          />
          {error && <Alert severity="error">{error.message}</Alert>}
        </DialogContent>
        <DialogActions>
          <LoadingButton variant="outlined" onClick={handleClose}>
            Cancel
          </LoadingButton>
          <LoadingButton variant="contained" loading={isPending} type="submit">
            Save
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default BrandModal;
